
/* Styles */
import styles from 'styles/goals-cards.module.scss';
import cn from 'classnames';

/* Material UI and other UI Dependencies */
import Typography from "@material-ui/core/Typography";

/* i18n */
import { useIntl } from 'react-intl';

/* Assets */
import IllustrationMoney from 'assets/images/Illustration_Money.svg';
import IllustrationTraining from 'assets/images/Illustration_Training.svg';
import IllustrationBriefCase from 'assets/images/Illustration_Briefcase.svg';

const illustrationDict = {
  boostEarnings: IllustrationMoney,
  similarSkills: IllustrationTraining,
  manyJobs: IllustrationBriefCase
}

const ExperienceCard =({
  type,
  onClick = ()=>{},
  active = false
}) => {
  
  const intl = useIntl();

  return(
    <div className={cn({
      [styles.card]: true,
      [styles.active]: active
    })} onClick={onClick}>
      <img
        alt="Goal"
        className={cn({
          [styles.goalsImage]: true,
          [styles.moneyImage]: type === 'boostEarnings',
          [styles.trainingImage]: type === 'similarSkills',
          [styles.briefcaseImage]: type === 'manyJobs',
        })}
        src={illustrationDict[type]}
      />
      <Typography variant="h5" component="h2" align="center">
        {intl.formatMessage({id: `onboarding.goals.${type}`,description:'string'})}
      </Typography>
    </div>
  )
}

export default ExperienceCard;